export const PERFORMANCE = {
  PERFORMANCE: 'PERFORMANCE',
  CLEAR: 'CLEAR',
}
